import makeStyles from '@mui/styles/makeStyles';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, FormControl, FormLabel, Grid, Radio, RadioGroup, FormHelperText } from '@mui/material';
import { ProductWithCurrencies } from '@shared/api';
import { DelayedLinearProgress } from '@widgets';

const RADIOS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
}));

interface Props {
  loading: boolean;
  products: ProductWithCurrencies[];
}

export const StepProduct = (props: Props) => {
  const classes = useStyles();

  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const reset = () => {
    setValue('eurCurrency', false);
    setValue('chfCurrency', false);
    setValue('usdCurrency', false);
    setValue('eurCreditLimit', '');
    setValue('chfCreditLimit', '');
    setValue('usdCreditLimit', '');
  };

  return (
    <>
      <DelayedLinearProgress className={classes.fullWidth} loading={props.loading} />
      <Grid container>
        <Grid item>
          <FormControl margin='normal' fullWidth error={!!errors.productName}>
            <FormLabel component='label'>Select a product *</FormLabel>
            <RadioGroup row>
              {props.products.map((product, idx) => (
                <FormControlLabel
                  key={idx}
                  label={product.name}
                  labelPlacement='end'
                  control={
                    <Controller
                      name='productName'
                      control={control}
                      rules={{ required: 'Product is required' }}
                      render={({ field }) => (
                        <Radio
                          color='primary'
                          {...field}
                          value={product.name}
                          checked={field.value === product.name}
                          onChange={(e) => {
                            field.onChange(e);
                            reset();
                          }}
                        />
                      )}
                    />
                  }
                />
              ))}
            </RadioGroup>
            {errors.productName?.message && <FormHelperText>{errors.productName.message as string}</FormHelperText>}
          </FormControl>
        </Grid>
      </Grid>
      {props.products && props.products.length > 0 && (
        <Grid container>
          <Grid item>
            <FormControl margin='normal' fullWidth>
              <FormLabel component='label'>Please confirm if this is a Fee Free Card *</FormLabel>
              <RadioGroup row>
                {RADIOS.map((radio, idx) => (
                  <FormControlLabel
                    key={idx}
                    label={radio.label}
                    labelPlacement='end'
                    control={
                      <Controller
                        name='fee'
                        control={control}
                        render={({ field: { onChange, ...field } }) => (
                          <Radio
                            color='primary'
                            {...field}
                            value={radio.value}
                            checked={field.value === radio.value}
                            onChange={() => onChange(radio.value)}
                          />
                        )}
                      />
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      )}
    </>
  );
};
